import { JobChangeStatusInterface } from '../../../interfaces/job-change-status.interface';

export class SetAwaitingJobStatus {
    public static readonly type = '[JobsPlacements] Set job awaiting status';

    constructor(public data: JobChangeStatusInterface) {}
}
